/*
 * @Description:
 * @Author:  Teemo Ding
 * @Date: 2021-04-14 15:10:57
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-15 14:07:08
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductContent/slice/index.ts
 */

import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import { message } from 'antd';
import _ from 'lodash';
import {
  generateDefaultState as _generateDefaultState,
  onCollapseOpen as _onCollapseOpen,
  assData,
  defaultStatus,
  hasError,
} from 'src/pages/SalesChannelProductsConfig/slice/reduxCommonFunctions';
import { NULL } from 'src/tools/constant';
import {
  EnumCollapseId,
  generateDefaultCarousel,
  generateDefaultContentDetails,
  generateDefaultSEOSetting,
  generateDefaultThumbnailImage,
} from '../common';

import {
  EnumReducers,
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getGeneralFeaturedProduct as _getGeneralFeaturedProduct,
  getGeneralMiniProgramPageInfo as _getGeneralMiniProgramPageInfo,
  getGeneralMiniProgramShare as _getGeneralMiniProgramShare,
  getH1TagUuid as _getH1TagUuid,
  getHasModified as _getHasModified,
  getLoaded as _getLoaded,
  getPageEnabled as _getPageEnabled,
  getSalesChannel as _getSalesChannel,
  getSalesChannelName as _getSalesChannelName,
  getState as _getState,
  getTarget,
  reducers,
} from 'src/pages/SalesChannelProductsConfig/slice/selectors';

import {
  moduleContentDynamicOnChange as _moduleContentDynamicOnChange,
  moduleContentOnChange as _moduleContentOnChange,
  moduleContentStaticOnChange as _moduleContentStaticOnChange,
  onModuleTypeChange as _onModuleTypeChange,
  handleOnModuleDuplicate,
} from 'src/constrains/DraggableModules/reduxFunctions';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';

import { convertDataFromServerToRedux } from '../tools';

import {
  request_ProductContent,
  request_SaveProductContent,
} from '@/src/request/salesChannel/product/content';

import { getI18nFromGeneral } from '@/src/tools/tools';
import arrayMove from 'array-move';

export { EnumCollapseId };

const fixedCollapse = [
  EnumCollapseId.seoSetting,
  EnumCollapseId.contentDetails,
  EnumCollapseId.carousel,
  EnumCollapseId.thumbnailImage,
  EnumCollapseId.reviewKeywords,
  EnumCollapseId.miniProgramPageInfo,
  EnumCollapseId.miniProgramShare,
];
const _defaultState = _generateDefaultState(fixedCollapse);
const seoSetting = generateDefaultSEOSetting();
const contentDetails = generateDefaultContentDetails();
const carousel = generateDefaultCarousel();
const thumbnailImage = generateDefaultThumbnailImage();
const defaultState = {
  moduleContentOrder: [], //{两个不变参数moduleType,draggableId}
  moduleContentStaticConfig: {},
  moduleContentDynamicConfig: {}, //理想情况下，这里还可以再拆，因为这里也是array，看接下来的需求吧, 若果更复杂了就拆， 扁平化，最好不出现index
  uuid: '',
  loaded: false,
  enabled: false,
  seoSetting,
  // longCanvas,
  contentDetails,
  carousel,
  alias: [],
  miniProgramShare: {},
  reviewKeywords: {
    text: '',
    tags: [],
  },
  type: '',
  thumbnailImage,
  averageRating: 0,
  reviewCount: 0,
  show: null,
  ..._defaultState,
  ...defaultStatus,
};
const _currentReducer = reducers(EnumReducers.productContent);

export const submitContent = createAsyncThunk(
  'submitSalesChannelProductContent',
  async ({ body, params, s }: any) => {
    const isPrimary = isCurrentPrimary();
    // const response = {};
    const response = await request_SaveProductContent(body, params);
    return { response, isPrimary };
  },
);

export const initProductContent = createAsyncThunk(
  'initSalesChannelProductContent',
  async ({ body, params }: any) => {
    const isPrimary = isCurrentPrimary();
    const response = await request_ProductContent(body, params);
    return { response, isPrimary };
  },
);

export const cloneProductContent = createAsyncThunk(
  'cloneSalesChannelProductContent',
  async ({ body, params }: any) => {
    const isPrimary = isCurrentPrimary();
    const response = await request_ProductContent(body, params);
    return { response, isPrimary };
  },
);

const salesChannelProductContent = createSlice({
  name: 'SalesChannelProductContent',
  initialState: defaultState,
  reducers: {
    onEnabledChange(state, action) {
      state.hasModified = true;
      state.enabled = action.payload;
    },
    initializeEmpty(state, action) {
      const defaultStateCopy = _.cloneDeep(defaultState);
      defaultStateCopy.salesChannelProductUuid = NULL;
      defaultStateCopy.salesChannelUuid = action.payload;
      defaultStateCopy.loaded = true;
      assData(state, defaultStateCopy);
    },
    onMiniProgramShareChange(state, action) {
      state.hasModified = true;
      state.miniProgramShare = {
        ...state.miniProgramShare,
        ...action.payload,
      };
    },
    onDuplicate(state, action) {
      handleOnModuleDuplicate(state, action);
    },
    moduleContentOnChange(state, action) {
      _moduleContentOnChange(state, action);
    },
    onModuleTypeChange(state, action) {
      _onModuleTypeChange(state, action.payload);
    },
    moduleContentStaticOnChange(state, action) {
      _moduleContentStaticOnChange(state, action);
    },
    moduleContentDynamicOnChange(state, action) {
      _moduleContentDynamicOnChange(state, action);
    },

    onCollapseOpen(state, action) {
      const { idArr = [] } = action.payload; //=>[id:string]
      _onCollapseOpen(state, idArr);
    },

    onSEOSettingOnChange(state, action) {
      state.hasModified = true;
      const { data } = action.payload;

      if (data.customized) {
        data.title = state.contentDetails.productName;
        data.description = state.contentDetails.productDescription;
      }
      state.seoSetting = { ...state.seoSetting, ...data };
    },

    onContentDetailsOnChange(state, action) {
      state.hasModified = true;
      const { data } = action.payload;
      state.contentDetails = { ...state.contentDetails, ...data };
    },

    onThumbnailImageOnSort(state, action) {
      const { from, to } = action.payload;
      state.hasModified = true;
      state.thumbnailImage.linkModules = arrayMove(
        state.thumbnailImage.linkModules,
        from,
        to,
      );
    },
    onThumbnailImageOnChange(state, action) {
      state.hasModified = true;
      const { index, data } = action.payload;
      state.thumbnailImage.linkModules[index] = {
        ...state.thumbnailImage.linkModules[index],
        ...data,
      };
    },
    onDynamicDataAdd(state, action) {
      state.hasModified = true;
      const { draggableId, data } = action.payload;
      state[draggableId].dynamicData.push(data);
    },
    onDynamicDataDelete(state, action) {
      state.hasModified = true;
      const { draggableId, index } = action.payload;
      state[draggableId].dynamicData.splice(index, 1);
    },

    onDynamicDataSort(state, action) {
      const { from, to, draggableId } = action.payload;
      state.hasModified = true;
      state[draggableId].dynamicData = arrayMove(
        state[draggableId].dynamicData,
        from,
        to,
      );
    },

    onDynamicDataChange(state, action) {
      state.hasModified = true;
      const { index, data, draggableId } = action.payload;
      if (data.coverImage) {
        //取消其他选择
        state[draggableId].dynamicData = state[draggableId].dynamicData.map(
          (d) => {
            d.coverImage = false;
            return d;
          },
        );
        state[draggableId].dynamicData[index] = {
          ...state[draggableId].dynamicData[index],
          ...data,
        };
      } else {
        state[draggableId].dynamicData[index] = {
          ...state[draggableId].dynamicData[index],
          ...data,
        };
      }
    },

    onDeleteAlias(state, action) {
      state.hasModified = true;
      state.alias.splice(action.payload, 1);
    },

    onStaticChange(state, action) {
      state.hasModified = true;
      const { draggableId, data } = action.payload;
      state[draggableId].staticData = {
        ...state[draggableId].staticData,
        ...data,
      };
    },
    addReviewKeywordsTextOnchange(state, action) {
      state.hasModified = true;
      const { text } = action.payload;
      state.reviewKeywords = {
        ...state.reviewKeywords,
        ...{ text },
      };
    },

    addReviewKeywordsTagsAdd(state, action) {
      state.hasModified = true;
      const { tags = [], text } = state.reviewKeywords;
      tags.unshift(text);
      state.reviewKeywords = {
        ...state.reviewKeywords,
        ...{ tags, text: '' },
      };
    },
    addReviewKeywordsTagsRemove(state, action) {
      state.hasModified = true;
      const { tags } = state.reviewKeywords;
      const { index } = action.payload;
      tags.splice(index, 1);
      state.reviewKeywords = {
        ...state.reviewKeywords,
        ...{ tags },
      };
    },

    onErrorChange(state, action) {
      const { id, status } = action.payload;
      state.collapseErrorMsgDisplay[id].hasError = status;
    },
    validation(state) {
      hasError(state, state.collapseErrorMsgDisplay || {});
    },
    resetData(state) {
      assData(state, defaultState);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(initProductContent.fulfilled, (state, action) => {
      const { response, isPrimary } = action.payload;
      const _data = convertDataFromServerToRedux(response, isPrimary) || {};
      assData(state, _data);
    });
    builder.addCase(cloneProductContent.fulfilled, (state, action) => {
      const { response, isPrimary } = action.payload;
      const _data = convertDataFromServerToRedux(response, isPrimary) || {};
      assData(state, _data);
      console.log('clone');
      state.hasModified = true;
    });
    //cloneProductContent
    builder.addCase(submitContent.fulfilled, (state, action) => {
      const { salesChannelProductUuid } = action.payload.response;
      message.success(
        getI18nFromGeneral('general.status.changessavesuccessfully'),
      );
      assData(state, { hasModified: false, salesChannelProductUuid });
    });
  },
});

export const getPageEnabled = () => {
  return _getPageEnabled(EnumReducers.productContent);
};

export const getCarousel = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.carousel;
    },
    (carousel) => {
      return carousel;
    },
  );
};
export const getThumbnailImage = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.thumbnailImage;
    },
    (thumbnailImage) => {
      return thumbnailImage;
    },
  );
};
export const getReviewKeywords = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.reviewKeywords;
    },
    (reviewKeywords) => {
      return reviewKeywords;
    },
  );
};
export const getProductType = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.productType;
    },
    (productType) => {
      return productType;
    },
  );
};

export const getProductUuid = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.salesChannelProductUuid;
    },
    (salesChannelProductUuid) => {
      return salesChannelProductUuid;
    },
  );
};
export const getContent = (id) => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData[id];
    },
    (content) => {
      return content;
    },
  );
};
export const getModulesContent = (draggableId) => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.moduleContentStaticConfig[draggableId];
    },
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.moduleContentDynamicConfig[draggableId];
    },

    (staticData, dynamicData) => {
      return {
        staticData: staticData || {},
        dynamicData: dynamicData || [],
      };
    },
  );
};

export const getAllAlias = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.alias;
    },
    (alias) => {
      return alias;
    },
  );
};
export const getContentDetails = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.contentDetails;
    },
    (contentDetails) => {
      return contentDetails;
    },
  );
};

export const getVisibleCollapse = (order) => {
  return createSelector(
    (state: any) => {
      const _r = [];
      for (const item of order) {
        const { draggableId: id } = item;
        const stateData = getTarget(state, _currentReducer);
        if (stateData.moduleContentStaticConfig[id].visible) {
          _r.push(id);
        }
      }
      return _r;
    },
    (status) => {
      return status;
    },
  );
};

export const getSeoSetting = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.seoSetting;
    },
    (seoSetting) => {
      return seoSetting;
    },
  );
};
export const getOpeningCollapse = (order) => {
  return createSelector(
    (state: any) => {
      const _r = [];
      for (const item of order) {
        const { draggableId: id } = item;
        const stateData = getTarget(state, _currentReducer);
        if (stateData.collapseOpen[id]) {
          _r.push(id);
        }
      }
      return _r;
    },
    (status) => {
      return status;
    },
  );
};
export const getCollapseStatus = (id) => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.collapseOpen[id];
    },
    (status) => {
      return status;
    },
  );
};
export const getOrder = () => {
  return createSelector(
    (state: any) => {
      const stateData = getTarget(state, _currentReducer);
      return stateData.moduleContentOrder;
    },
    (order) => {
      return order;
    },
  );
};

export const getAllState = () => {
  return createSelector(
    (state: any) => getTarget(state, _currentReducer),
    (allState) => {
      return allState;
    },
  );
};

export const getCollapseOpenStatus = (id) => {
  return _getCollapseOpenStatus(EnumReducers.productContent, id);
};

export const getCollapseValidationMsgDisplay = (id) => {
  return _getCollapseValidationMsgDisplay(EnumReducers.productContent, id);
};

export const getGeneralFeaturedProduct = () => {
  return _getGeneralFeaturedProduct(EnumReducers.productContent);
};

export const getState = () => {
  return _getState(EnumReducers.productContent);
};

export const getHasModified = () => {
  return _getHasModified(EnumReducers.productContent);
};

export const getSalesChannel = () => {
  return _getSalesChannel(EnumReducers.productContent);
};

export const getSalesChannelName = () => {
  return _getSalesChannelName(EnumReducers.productContent);
};
export const getLoaded = () => {
  return _getLoaded(EnumReducers.productContent);
};
export const getH1TagUuid = () => {
  return _getH1TagUuid(EnumReducers.productContent);
};

export const getGeneralMiniProgramPageInfo = () => {
  return _getGeneralMiniProgramPageInfo(EnumReducers.productContent);
};

export const getGeneralMiniProgramShare = () => {
  return _getGeneralMiniProgramShare(EnumReducers.productContent);
};

export const {
  onEnabledChange,
  onCollapseOpen,
  onMiniProgramShareChange,
  onSEOSettingOnChange,
  moduleContentStaticOnChange,
  moduleContentDynamicOnChange,
  onContentDetailsOnChange,
  onThumbnailImageOnChange,
  initializeEmpty,
  onDynamicDataAdd,
  onThumbnailImageOnSort,
  onDynamicDataDelete,
  onDynamicDataChange,
  onDynamicDataSort,
  onErrorChange,
  onDeleteAlias,
  addReviewKeywordsTextOnchange,
  validation,
  resetData,
  onStaticChange,
  moduleContentOnChange,
  onModuleTypeChange,
  addReviewKeywordsTagsAdd,
  addReviewKeywordsTagsRemove,
  onDuplicate,
} = salesChannelProductContent.actions;

export default salesChannelProductContent.reducer;
